/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { setTitle } from "@lemmonhq/orders";
export * from "./subpages/index";

// Stock, purchasing and cross-shop (marketplace) ordering.
// See docs/plans/inventory_and_costing/02_inventory_page.md.
export const InventoryPage = defineComponent({
  name: "InventoryPage",
  setup() {
    const { t } = useLocalization();
    onMounted(() => {
      setTitle(t("inventory.nav.page_title"));
    });

    return () => {
      const subpages = [
        {
          name: t("inventory.nav.overview"),
          icon: "space_dashboard",
          href: "/app/inventory/overview",
        },
        {
          name: t("inventory.nav.stock"),
          icon: "inventory",
          href: "/app/inventory/stock",
        },
        {
          name: t("inventory.nav.counts"),
          icon: "checklist",
          href: "/app/inventory/counts",
        },
        {
          name: t("inventory.nav.orders"),
          icon: "shopping_cart",
          href: "/app/inventory/orders",
        },
        {
          name: t("inventory.nav.deliveries"),
          icon: "local_shipping",
          href: "/app/inventory/deliveries",
        },
        {
          name: t("inventory.nav.invoices"),
          icon: "request_quote",
          href: "/app/inventory/invoices",
        },
        {
          name: t("inventory.nav.suppliers"),
          icon: "storefront",
          href: "/app/inventory/suppliers",
        },
        {
          name: t("inventory.nav.waste"),
          icon: "delete_sweep",
          href: "/app/inventory/waste",
        },
        {
          name: t("inventory.nav.margins"),
          icon: "monitoring",
          href: "/app/inventory/margins",
        },
        {
          name: t("inventory.nav.marketplace"),
          icon: "travel_explore",
          href: "/app/inventory/marketplace",
        },
      ];

      return (
        <PageComponent
          title={t("inventory.nav.page_title")}
          titleIcon="inventory"
          subpages={subpages}
        >
          <RouterView />
        </PageComponent>
      );
    };
  },
});
